const linkedinConversion = () => {
  const linkedintracker = new Image(1, 1);
  linkedintracker.src = 'https://px.ads.linkedin.com/collect/?pid=2062682&conversionId=2210266&fmt=gif';
  document.body.appendChild(linkedintracker);
};

export default linkedinConversion;
